import projectsStyles from "./projects.module.css";
import React, { Dispatch, FC, SetStateAction } from "react";
import { IProject, projects } from "../../constants";
import linkout from "../../images/link_out.svg";

interface IProjectsProps {
  project: IProject;
  setProject: Dispatch<SetStateAction<IProject>>;
}
const Projects: FC<IProjectsProps> = ({ project, setProject }) => {
  return (
    <div className={projectsStyles.projects}>
      <ul className={projectsStyles.projectsList}>
        {projects.map((pr, index) => (
          <li key={index}>
            <button
              className={`${projectsStyles.project} ${
                pr.title === project.title ? projectsStyles.active : ""
              }`}
              onClick={() => setProject(pr)}
            >
              {pr.title}
            </button>
          </li>
        ))}
      </ul>
      <article className={projectsStyles.desc}>
        <h3 className={projectsStyles.title}>{project.title}</h3>
        <p className={projectsStyles.text}>{project.description}</p>
        <p className={projectsStyles.text}>Used technologies: {project.tech}</p>
        <a
          className={projectsStyles.link}
          target="_blank"
          rel="noopener noreferrer"
          href={project.link}
        >
          Github
          <img
            src={linkout}
            className={projectsStyles.img}
            alt="Link to Github"
          />
        </a>
      </article>
    </div>
  );
};

export default Projects;
